import { TaskRating } from 'contexts/assessment'

const MAX_ENCOUNTER_ACTIVITY_SCORE = 4

export const MIN_REQUIRED_RATINGS = 7

export const isValidScore = (score: number | undefined | null): score is number =>
    score !== undefined && score !== null && score > 0 && isFinite(score)

export const calculateFinalScore = (scores: Array<number | undefined | null>): number | undefined => {
    if (scores.length > 0) {
        const validScores = scores.filter(isValidScore)
        const minRequired = Math.min(MIN_REQUIRED_RATINGS, scores.length)
        if (validScores.length >= minRequired && validScores.length > 0) {
            const sum = validScores.reduce((acc, score) => acc + score, 0)
            return Math.round((sum / (validScores.length * MAX_ENCOUNTER_ACTIVITY_SCORE)) * 100)
        }
    }
    return undefined
}

export const hasMinimumRatingsGiven = (scores: Map<string, number>, tasksRatings: TaskRating[]): boolean => {
    if (tasksRatings.length === 0) return false
    const validScoresCount = tasksRatings.filter(task => isValidScore(scores.get(task.rating.id))).length
    const minRequired = Math.min(MIN_REQUIRED_RATINGS, tasksRatings.length)
    return validScoresCount >= minRequired
}

// Strict scoring (all ratings required)
export const calculateFinalScoreStrict = (scores: Array<number | undefined | null>, totalRatings: number): number | undefined => {
    const validScores = scores.filter(isValidScore)
    if (validScores.length === totalRatings && validScores.length > 0) {
        const sum = validScores.reduce((acc, score) => acc + score, 0)
        return Math.round((sum / (totalRatings * MAX_ENCOUNTER_ACTIVITY_SCORE)) * 100)
    }
    return undefined
}

export const hasAllRatingsGiven = (scores: Map<string, number>, tasksRatings: TaskRating[]): boolean => {
    if (tasksRatings.length === 0) return false
    const validScoresCount = tasksRatings.filter(task => isValidScore(scores.get(task.rating.id))).length
    return validScoresCount === tasksRatings.length
}
